import { Footer } from '@Components/sp/footer/view';
import { Header } from '@Components/sp/header/view';
import React from 'react';
import ImportantNoticeBar from '@Components/important_notice_bar/view';

import s from './style.module.css';

type PageProps = {
    children: React.ReactNode;
    contentHead?: React.ReactNode;
    contentFooter?: React.ReactNode;
    courseId?: string;
    isInquiry?: boolean;
    // SSR時のヘッダー「選択中」ナビ判定（getPathResolver）用の実際のリクエストパス。
    // 呼び出し元（Detail/DetailSp）がrailsContext.pathnameから渡す（PR #2082 Point2対応）。
    // SP版Headerは現状getPathResolverを使っていないため未使用だが、PC版と構造を揃えるために受け取る
    currentPath?: string;
};
const _Page: React.VFC<PageProps> = (props: PageProps) => {
    return (
        <div className={s.page}>
            <Header courseId={props.courseId} isInquiry={props.isInquiry} currentPath={props.currentPath} />
            <div className={s.page_contents}>
                <ImportantNoticeBar isSp />
                {props.contentHead}
                {props.children}
                {props.contentFooter}
            </div>
            <Footer />
        </div>
    );
};
export default _Page;
